import React from 'react'
import Footer from '../component/Footer'
import Hero from '../component/Hero'
import Navbar from '../component/Navbar'
import Project from '../component/Project'

const ProjectRoute = () => {
  return (
    <>
    <Navbar/>
    <Hero/>
    <Project/>
    <Footer/>
    </>
  )
}

export default ProjectRoute